<template>
  <div>
    <a class="ag-table-button" href="javascript:;" @click="goTo()">
      {{$t("applyDecision")}}</a
    >
  </div>
</template>

<script>
export default {
  name: "rowCustomRouter",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      display: "",
    };
  },
  created() {
    this.display = this.data[this.options.displayField];
  },
  methods: {
    goTo() {
      this.$router.push(this.options.route(this.data));
    },
  },
};
</script>
